import * as React from "react";
const SvgWithdraw2 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 5H13V13.5H3V5Z", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 2.5H11L13 5H3L5 2.5Z", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 6.75L8 11.75", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 9.75L8 11.75L6 9.75", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgWithdraw2;
